import React from "react";

import { Info } from "lucide-react";

import { Product } from "~/types/product";

interface PriceRangesInfoProps {
  selectedProduct: Product;
  priceRanges?: Array<{ min: number; max: number; price: number }>;
}

const PriceRangesInfo: React.FC<PriceRangesInfoProps> = ({
  selectedProduct,
  priceRanges = [],
}) => {
  if (priceRanges.length === 0) return null;

  return (
    <div className="col-span-12 mt-2 rounded-md bg-muted/30 p-3">
      <div className="mb-1 flex items-center gap-2 text-sm font-medium text-muted-foreground">
        <Info size={16} />
        <span>
          Rangos de precios disponibles para {selectedProduct.short_name}:
        </span>
      </div>
      <div className="mt-1 grid grid-cols-3 gap-x-4 gap-y-1">
        {priceRanges.map((range, idx) => (
          <div key={idx} className="text-sm">
            <span className="font-medium">${range.price.toLocaleString()}</span>
            <span className="ml-1 text-muted-foreground">
              (
              {range.min.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 1,
              })}{" "}
              -{" "}
              {range.max === 2147483647
                ? "∞"
                : range.max.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                  })}{" "}
              unidades)
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PriceRangesInfo;
